import { isDefAndNotNull } from '@utils/def';

/**
 * For displaying errors from a thunk to the user
 *
 *
 * @param {Object} error - The error object to extract a message from
 * @returns {String} The error message
 */
export function getThunkError(error: any) {
  if (isDefAndNotNull(error) && typeof error === 'object') {
    if (
      isDefAndNotNull(error?.response?.data?.data) &&
      error?.response?.data?.data !== ''
    ) {
      return error?.response?.data?.data;
    } else if (isDefAndNotNull(error?.response?.data?.error_msg)) {
      return error?.response?.data?.error_msg;
    } else {
      return error.message;
    }
  }
  return 'An error occurred';
}
